import { ReactElement } from 'react';
import styles from '@components/main/css/first-loader.module.css';

export default function FirstLoader(): ReactElement {
	return (
		<div className={styles.loader}>
			<div className={styles.box} />
		</div>
	);
}
